const fallbackMessage = "Autoschedule could not complete. Please try again or contact support.";

export function completeAutoschedulePreview(request, { onSuccess, onError, onFinished }) {
  return request.then(
    (response) => {
      onSuccess(response.data);
      onFinished();
    },
    (error) => {
      const detail = error.response?.data?.error;
      onError(typeof detail === "string" && detail.trim() ? detail : fallbackMessage);
      onFinished();
    }
  );
}
